import { render, staticRenderFns } from "./KpiEditorViewUsingMVC.vue?vue&type=template&id=84c8cf62&scoped=true&"
import script from "./KpiEditorViewUsingMVC.vue?vue&type=script&lang=js&"
export * from "./KpiEditorViewUsingMVC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84c8cf62",
  null
  
)

export default component.exports